export var TopLevelRegion;
(function (TopLevelRegion) {
    TopLevelRegion["EMEA"] = "EMEA";
    TopLevelRegion["AMER"] = "AMER";
    TopLevelRegion["APAC"] = "APAC";
    TopLevelRegion["Unspecified"] = "unspecified";
})(TopLevelRegion || (TopLevelRegion = {}));
export var regionOptions = Object.values(TopLevelRegion)
    .filter(function (value) { return value !== TopLevelRegion.Unspecified; })
    .map(function (v) { return ({
    label: v,
    value: v,
}); });
//# sourceMappingURL=TopLevelRegion.js.map